export const hasQueryFlag = (search, param) => {
  const searchParams = new URLSearchParams(search)

  return searchParams.has(param)
}

export const buildSearchWithFlag = (search, param, enabled) => {
  const searchParams = new URLSearchParams(search)

  searchParams.delete(param)

  const serializedParams = searchParams.toString()

  if (!enabled) {
    return serializedParams ? `?${serializedParams}` : ""
  }

  const encodedParam = encodeURIComponent(param)

  return serializedParams ? `?${serializedParams}&${encodedParam}` : `?${encodedParam}`
}
